export interface RootContainerId {
  displayDescription: string;
  deploymentDate: string;
  displayName: string;
  name: string;
  description: string;
  deployedBy: string;
  id: string;
  activationState: string;
  version: string;
  configurationState: string;
  last_update_date: string;
  actorinitiatorid: string;
}

export interface iListTaskHumanUserId {
  displayDescription: string;
  executedBy: string;
  rootContainerId: RootContainerId;
  assigned_date: string;
  displayName: string;
  executedBySubstitute: string;
  dueDate: string;
  description: string;
  type: string;
  priority: string;
  actorId: string;
  processId: string;
  caseId: string;
  name: string;
  reached_state_date: string;
  rootCaseId: string;
  id: string;
  state: string;
  parentCaseId: string;
  last_update_date: string;
  assigned_id: string;
  responsable?: string;
  alarma?: string;
  ticketRedmine?: string;
  ci?: string;
  EscalableN3?: boolean;
  prioridadLabel?: string;
  Proceso: string;
}

export interface iTask {
  id: string;
  displayName: string;
  caseId: string;
}
export const defaultRootContainerId: RootContainerId = {
  displayDescription: "",
  deploymentDate: "",
  displayName: "",
  name: "",
  description: "",
  deployedBy: "",
  id: "",
  activationState: "",
  version: "",
  configurationState: "",
  last_update_date: "",
  actorinitiatorid: "",
};
export const defaultListTaskHumanUserId: iListTaskHumanUserId = {
  displayDescription: "",
  executedBy: "",
  rootContainerId: defaultRootContainerId,
  assigned_date: "",
  displayName: "",
  executedBySubstitute: "",
  dueDate: "",
  description: "",
  type: "",
  priority: "",
  actorId: "",
  processId: "",
  caseId: "",
  name: "",
  reached_state_date: "",
  rootCaseId: "",
  id: "",
  state: "",
  parentCaseId: "",
  last_update_date: "",
  assigned_id: "",
  Proceso: "",
};
